var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"GoTop"},on:{"click":function($event){return _vm.GoTop()}}},[(_vm.flag)?_c('img',{attrs:{"src":require("@/assets/img/returnTop.png"),"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }